<template>
    <div class="swipper-timeline-wrapper">
        <div class="container-fluid container-timeline-wrapper">
            <div class="row row-timeline-wrapper justify-content-center">
                <div class="col-12 col-xxl-7 col-swiper-img">
                    <div class="swiper-timeline-image">
                        <div class="swiper-wrapper">
                            <div
                                v-for="(slide, index) in sectionBlock.slide"
                                :key="'swiper-img-' + index"
                                class="swiper-slide"
                            >
                                <img :src="slide.img.url" :alt="slide.img.title" />
                            </div>
                        </div>
                        <div class="swiper-pagination d-none d-xl-block"></div>

                        <div class="swiper-button-prev d-xl-block"></div>
                        <div class="swiper-button-next d-xl-block"></div>

                    </div>
                </div>

                <div class="col-12 col-xxl-5 overflow-hidden py-5 pt-xl-4 px-5">
                    <div>
                        <div class="swiper-timeline-date">
                            <div class="swiper-wrapper">
                                <div
                                    v-for="(slide, index) in sectionBlock.slide"
                                    :key="'swiper-text' + index"
                                    class="swiper-slide"
                                >
                                    <p class="slide-date" v-html="slide.slideDate"></p>
                                </div>
                            </div>
                        </div>

                        <div class="swiper-timeline-text">
                            <div class="swiper-wrapper">
                                <div
                                    v-for="(slide, index) in sectionBlock.slide"
                                    :key="'swiper-text' + index"
                                    class="swiper-slide"
                                >
                                    <div class="img-description" v-html="slide.slideText"></div>
                                </div>
                            </div>
                            <div class="swiper-pagination d-xxl-none"></div>

                            <div class="swiper-button-prev d-xxl-none"></div>
                            <div class="swiper-button-next d-xxl-none"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
// import AssetLoader from '@/components/helpers/AssetLoader'

// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle.js'

// import styles bundle
import 'swiper/swiper-bundle.min.css'

export default {
    name: 'swipperTimeline',
    components: {
        // AssetLoader
    },
    props: {
        sectionBlock: {
            type: Object,
            required: true,
        },
    },
    watch: {
        pageIsLoaded: {
            async handler(pageIsLoaded) {
                if (pageIsLoaded) {
                    // Page loaded with Data

                    setTimeout(function () {
                        const swiper_date = new Swiper('.swiper-timeline-date', {
                            // Optional parameters
                            // loop: true,
                            autoHeight: true,
                            slidesPerView: 1,
                            spaceBetween: 60,
                            allowTouchMove: false,
                            // If we need pagination

                        })

                        const swiper_img = new Swiper('.swiper-timeline-image', {
                            // Optional parameters
                            // loop: true,
                            autoHeight: true,
                            spaceBetween: 0,
                            slidesPerView: 1,
                            grabCursor: true,
                            // If we need pagination
                            pagination: {
                                el: '.swiper-pagination',
                                type: 'fraction',
                            },
                            // Navigation arrows
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                            controller: {
                                by: 'container'
                            },

                        })
                        const swiper_text = new Swiper('.swiper-timeline-text', {
                            // Optional parameters
                            // loop: true,
                            autoHeight: false,
                            slidesPerView: 1,
                            effect: "fade",
                            spaceBetween: 60,
                            allowTouchMove: false,
                            // If we need pagination

                            pagination: {
                                el: '.swiper-pagination',
                                type: 'fraction',
                            },
                            // Navigation arrows
                            navigation: {
                                nextEl: '.swiper-button-next',
                                prevEl: '.swiper-button-prev',
                            },
                            controller: {
                                control: [swiper_date, swiper_img],
                                by: 'container'
                            },

                        })

                        swiper_img.controller.control = [swiper_text, swiper_date];
                    }, 2000)
                }
            },
            immediate: true,
        },
    },


    computed: {
        pageIsLoaded() {
            return this.contentIsLoaded && this.globalsIsLoaded
        },
        ...mapState(['contentIsLoaded', 'globalsIsLoaded']),
        ...mapGetters(['seo', 'content', 'globals']),
    },
    methods: {
        ...mapActions(['setErrorsReportMsg']),
    },
    // On loaded...
    mounted() {},
}
</script>
